export enum DeliveryStatus {
  RETURN_TO_SENDER = 'RETURN_TO_SENDER',
}
